import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { withSiteData } from 'react-static';
import Helmet from 'react-helmet';
import { appsFlyerBannerScript } from '../../appsflyer';
import { googleTagSrc, googleTagScript, googleTagConsentScript } from '../../googleTag';

const defaultMetadata = defineMessages({
  title: {
    id: 'index.meta.title',
    defaultMessage: 'The Ultimate Classical Music Streaming App | IDAGIO',
  },
  description: {
    id: 'index.meta.description',
    defaultMessage:
      'The ultimate classical music collection in one app ✓Exclusive video concerts ✓Lossless sound quality  ✓Best search ✓Curated by performers and experts ▷ Discover IDAGIO now',
  },
});

const metaDataDecorator = metaData => {
  const { title, description, ogTitle, ogDescription, ogImage, noIndex } = metaData;
  return {
    title: title || defaultMetadata.title,
    description: description || defaultMetadata.description,
    ogTitle: ogTitle || title || defaultMetadata.title,
    ogDescription: ogDescription || description || defaultMetadata.description,
    ogImage: ogImage || 'https://d21as4hugkzy6u.cloudfront.net/images/opengraph/og-image.jpg?r=1',
    noIndex,
  };
};

const HelmetWrapper = ({ intl, data, appDomain, showSmartBanner, gtmContainerId }) => {
  const strings = metaDataDecorator(data);
  Object.keys(strings).forEach(key => {
    if (strings[key] && strings[key].hasOwnProperty('id')) {
      const { values, ...message } = strings[key];
      strings[key] = intl.formatMessage(message, values);
    }
  });

  return (
    <Helmet>
      <title>{strings.title}</title>

      {strings.description && <meta name="description" content={strings.description} />}
      {strings.ogTitle && <meta property="og:title" content={strings.ogTitle} />}
      {strings.ogTitle && <meta name="twitter:title" content={strings.ogTitle} />}
      {strings.ogDescription && <meta property="og:description" content={strings.ogDescription} />}
      {strings.ogDescription && <meta name="twitter:description" content={strings.ogDescription} />}
      {strings.ogImage && <meta property="og:image" content={strings.ogImage} />}
      {strings.ogImage && <meta name="twitter:image" content={strings.ogImage} />}
      {strings.noIndex && <meta name="robots" content="noindex" />}
      {showSmartBanner && (
        <meta
          name="apple-itunes-app"
          content={`app-id=1014917700, app-argument=${appDomain}/discover`}
        />
      )}
      <script>{appsFlyerBannerScript}</script>
      <script>{googleTagConsentScript}</script>
      <script async src={googleTagSrc} />
      <script>{googleTagScript}</script>
      {gtmContainerId && (
        <noscript>{`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}</noscript>
      )}
    </Helmet>
  );
};

HelmetWrapper.propTypes = {
  data: PropTypes.object,
  intl: intlShape,
  appDomain: PropTypes.string.isRequired,
  showSmartBanner: PropTypes.bool,
  gtmContainerId: PropTypes.string,
};

export default withSiteData(injectIntl(HelmetWrapper));



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/helmet/Helmet.js